import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["drawer", "backdrop", "panel"]

  connect() {
    this.isOpen = false
    this._onKeydown = this._onKeydown.bind(this)
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.show()
    }
  }

  show() {
    if (this.isOpen) return
    this.isOpen = true
    this.drawerTarget.style.display = ""

    // Trigger reflow before adding transition classes
    this.drawerTarget.offsetHeight

    this.backdropTarget.classList.remove("opacity-0")
    this.backdropTarget.classList.add("opacity-75")
    this.panelTarget.classList.remove("translate-x-full")
    this.panelTarget.classList.add("translate-x-0")
    document.body.style.overflow = "hidden"
  }

  close() {
    if (!this.isOpen) return
    this.isOpen = false

    this.backdropTarget.classList.remove("opacity-75")
    this.backdropTarget.classList.add("opacity-0")
    this.panelTarget.classList.remove("translate-x-0")
    this.panelTarget.classList.add("translate-x-full")
    document.body.style.overflow = ""

    setTimeout(() => {
      if (!this.isOpen) {
        this.drawerTarget.style.display = "none"
      }
    }, 500)
  }

  _onKeydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close()
    }
  }
}
